import script from "./FAQView.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQView.vue?vue&type=script&setup=true&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=1449aedc&lang=scss"

const __exports__ = script;

export default __exports__